module.exports = __webpack_public_path__ + "img/bollettino-header.9b50ec60.jpg";